import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@greenkub-fronts/shared/interface';
import { initSignaturePageUseCase } from '@greenkub-fronts/domain/signature';
import {
  DocumentSignatureContainer,
} from '../../ui/web/document-signature-container/document-signature-container';

interface DocumentSignatureContainerProps {
  isSignature?: boolean;
  fromExisting?: boolean;
  toGenerate?: boolean;
}

export function DocumentSignatureContainerFeature (
  props: DocumentSignatureContainerProps,
) {
  const { isSignature = true, fromExisting = false, toGenerate = true } = props;

  const {
    projectToken,
    projectId,
    documentId,
    documentSlug,
    upsellId,
    upsellToken,
  } = useParams();

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(
      initSignaturePageUseCase({
        isSignature,
        fromExisting,
        toGenerate,
        projectToken,
        projectId,
        documentId,
        documentSlug,
        upsellId,
        upsellToken,
      }),
    );
  }, [projectId, projectToken]);

  return <DocumentSignatureContainer />;
}
